import Component from '@bythepixel/component-loader';
import config from './config';

const { selectors } = config;

export default class CategorySelector extends Component {
  static selector = '[data-comp-category-selector]';

  constructor(containerEl) {
    super(containerEl);
    this.activePage = containerEl.querySelector(selectors.activePage);

    this.mount();
  }

  activePageIsOffScreen() {
    const PADDING = 20;
    const { left, right } = this.activePage.getBoundingClientRect();
    const { innerWidth } = window;

    const offRightEdge = (right + PADDING) > innerWidth;
    const offLeftEdge = left < 0;

    return offLeftEdge || offRightEdge;
  }

  scrollToCurrentCategory() {
    if (!this.activePageIsOffScreen()) return;

    const SCROLL_OFFSET = 24;
    const { $container, activePage } = this;

    $container.scrollTo({
      left: activePage.offsetLeft - SCROLL_OFFSET,
      behavior: 'smooth'
    });
  }

  mount() {
    this.scrollToCurrentCategory();
  }
}
